import { render, staticRenderFns } from "./loyalty-health.vue?vue&type=template&id=71f903fc&scoped=true"
import script from "./loyalty-health.vue?vue&type=script&lang=js"
export * from "./loyalty-health.vue?vue&type=script&lang=js"
import style0 from "./loyalty-health.vue?vue&type=style&index=0&id=71f903fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f903fc",
  null
  
)

export default component.exports